import $ from "jquery";

// https://developers.google.com/youtube/iframe_api_reference

let player;

window.onYouTubePlayerAPIReady = function () {
    player = new YT.Player('videoYouTube', {
        events: {
            'onReady': onPlayerReady,
        }
    });
};

function onPlayerReady(event) {
    $('.play-youtube').on('click', function (event) {
        setTimeout(()=>{
            player.playVideo();
        }, 200);
    });
}

$(function () {
    const $button = $('.play-youtube');
    const $frame = $('#videoYouTube');

    if ($button.length === 0 || $frame.length === 0) {
        return;
    }

    let tag = document.createElement('script');
    let firstScriptTag = document.getElementsByTagName('script')[0];

    tag.src = "//www.youtube.com/player_api";

    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
});
